import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            if ($(".error-page").length) {
                gsap.to(".error-page .error-container .error-svg .svg-item:nth-child(1) .item-path", {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                    delay: 0.6,
                    duration: 0.8,
                    ease: defaultEase
                })
                
                gsap.to(".error-page .error-container .error-svg .svg-item:nth-child(2) .item-path", {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                    delay: 0.7,
                    duration: 0.8,
                    ease: defaultEase
                })
               
                gsap.to(".error-page .error-container .error-svg .svg-item:nth-child(3) .item-path", {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                    delay: 0.8,
                    duration: 0.8,
                    ease: defaultEase
                })
               
                gsap.to(".error-page .error-container .error-content h2", {
                    y: 0,
                    opacity: 1,
                    delay: 0.9,
                    duration: 0.8,
                    ease: defaultEase
                })
               
                gsap.to(".error-page .error-container .error-content p", {
                    y: 0,
                    opacity: 1,
                    delay: 0.95,
                    duration: 0.8,
                    ease: defaultEase
                })
               
                gsap.to(".error-page .error-container .error-content .content-btn", {
                    y: 0,
                    opacity: 1,
                    delay: 1,
                    duration: 0.8,
                    ease: defaultEase
                })
            }
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });
})